import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const HeaderBar = styled('header')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 3,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  background: alpha(theme.palette.background.default, 0.8),
  padding: '1.5rem 1rem',

  [theme.breakpoints.up('lg')]: { padding: '1.5rem 10rem' },
  [theme.breakpoints.up('md')]: { padding: '1.5rem 80px' },
}));

export const HeaderContent = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const LogoContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
}));

export const LogoMark = styled('img')(() => ({
  width: '2rem',
  height: '2rem',
}));

export const LogoWordmark = styled('img')(() => ({
  width: '4.5rem',
  height: 'auto',
}));

export const ActionButton = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '3.5rem',
  height: '3rem',
  padding: 0,
  border: 'none',
  borderRadius: '50%',
  background: theme.palette.background.paper,
  cursor: 'pointer',
  transition: 'transform 160ms ease, background-color 160ms ease',

  '&:hover': {
    transform: 'scale(1.06)',
  },

  '&:active': {
    transform: 'scale(0.98)',
  },

  '& img': {
    width: '1.5rem',
    height: '1.5rem',
    display: 'block',
  },
}));

export const WhatsLink = styled('a')(() => ({
  cursor: 'pointer',
}));
